import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(authed)/people/page.tsx");
